<template lang="pug">
app-page(:fab-items="fabItems" title="Мои дела")
  v-container(fluid p-0 v-if="currentDoc!=null")
    v-layout
      app-toolbar(:title="`Дело № ${ caseNumber } | ${ currentDoc.name }`" back)
            

    v-layout(align-start)
      ResponseDoc(:caseId="caseId")

</template>

<script>
import { mapGetters } from 'vuex'
import ResponseDoc from './components/CaseResponseDoc'

export default {
  components: {
    ResponseDoc
  },

  props: {
    caseId: null,
    docId: null
  },

  mounted() {
    this.$store.dispatch('courtCase/DOC_INIT', { caseId: this.caseId, docId:this.docId })
  },

  data () {
    return {
      valid: true,
    }
  },

  computed: {
    ...mapGetters('courtCase', ['caseNumber', 'currentDoc']),

    fabItems () {
      return []
    },

  }
}
</script>

